<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 3" :key="`line_loader_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <v-row dense class="text-h4">Sip Configurações</v-row>
      <v-form ref="form">
        <v-col cols="3">
          <v-switch dense class="ml-2" v-model="form.sipActive" label="Habilitar Sip?" />
        </v-col>
        <v-row dense class="mt-4">
          <v-col cols="4">
            <v-text-field
              dense
              outlined
              v-model="form.Port"
              label="Porta"
              type="number"
              :error-messages="PortErrors"
              @input="$v.form.Port.$touch()"
              @blur="$v.form.Port.$touch()"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapGetters, mapActions } from 'vuex'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { registerVuexModule } from '@/utils/vuexUtils'

import sipConfigStore from '../_store'
import sipHttpService from '../_services/sipHttpService'
import { validateData, validateComputed } from '../_validates'

export default {
  components: { FixedButtons, Snackbar },
  mixins: [validationMixin],

  data: () => ({
    showSkeleton: true,
    snackbar: false,
    isAlreadyRegistered: false,
    text: '',
    form: {
      Port: '5061',
      sipActive: false
    },
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('sipConfigModulePABXStore', ['getSipConfig']),
  },

  async created() {

    registerVuexModule(this.$store, 'sipConfigModulePABXStore', sipConfigStore)
    await this.buscarSipConfig()

    this.form = {...this.getSipConfig}
    
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('sipConfigModulePABXStore', ['buscarSipConfig']),

    async salvar() {
      this.pararLoader.parar = false

      if (!this.$refs.form.validate()) {
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        await sipHttpService.putSipConfig(this.form)
        this.$router.back()
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }

      
      
      this.pararLoader.parar = true
    },

    cancelar() {
      this.$router.back()
    },

    novaLocalNet() {
      this.qtdLocalNet += 1
    },

    removeLocalNet(key) {
      this.qtdLocalNet -= 1
      this.local_netIp.splice(key, 1)
      this.local_netMask.splice(key, 1)
    },
  },
}
</script>
